export default "__VITE_ASSET__Vj$$zHo2__"